"use client";

import { hasSupplementalUiCopy } from "@/config/locale";
import { ShoppingBagIcon } from "lucide-react";
import { useLocale, useTranslations } from "next-intl";
import { useCart } from "./cart-context";

interface CartButtonProps {
	itemCount: number;
}

export function CartButton({ itemCount }: CartButtonProps) {
	const { openCart } = useCart();
	const locale = useLocale();
	const t = useTranslations("cart");

	return (
		<button
			type="button"
			onClick={openCart}
			data-testid="CartNavItem"
			className="hover:border-primary/30 hover:bg-primary/5 relative inline-flex h-9 w-9 items-center justify-center rounded-lg border border-transparent text-foreground transition-colors hover:text-primary lg:h-10 lg:w-10"
		>
			<ShoppingBagIcon className="h-5 w-5" aria-hidden="true" />
			{itemCount > 0 && (
				<span
					aria-hidden={hasSupplementalUiCopy(locale) ? true : undefined}
					// Key change remounts the element, restarting the CSS animation
					key={itemCount}
					className="absolute -right-0.5 -top-0.5 flex h-4 w-4 animate-cart-badge-pop items-center justify-center rounded-full bg-foreground text-[10px] font-medium text-background"
				>
					{itemCount > 9 ? "9+" : itemCount}
				</span>
			)}
			<span className="sr-only">
				{hasSupplementalUiCopy(locale)
					? `${t("yourBag")} · ${t("items", { count: itemCount })}`
					: `${itemCount} item${itemCount !== 1 ? "s" : ""} in cart, view bag`}
			</span>
		</button>
	);
}
